"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Suggestion_1 = require("./Suggestion");
Object.defineProperty(exports, "Suggestion", { enumerable: true, get: function () { return Suggestion_1.Suggestion; } });
//# sourceMappingURL=index.js.map